import React, {useState} from "react";
import Button from "../../shared/components/Button";
import FormError from "../../shared/components/forms/FormError";
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Trans, useTranslation } from 'react-i18next';
import styles from "./StripeElements.module.scss";


export default function NewPaymentElementForm(props) {
  const { t } = useTranslation("common");

  const {
    submitting,
    errors,
    clientSecret,
    textClass = "u-centered",
    buttonsClass = "buttons",
  } = props;

  const stripe = useStripe();
  const elements = useElements();
  
  const [stripeErrorMessage, setStripeErrorMessage] = useState(null);
  const [submittingToken, setSubmittingToken] = useState(false);
  const [stripeFocused, setStripeFocused] = useState(false);
  const [stripeErrored, setStripeErrored] = useState(false);

  async function submit(event) {
    event.preventDefault();

    if (!stripe || !elements) {
      // Shouldn't happen: stripe isn't loaded yet.
      return;
    }

    setSubmittingToken(true);

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit();
    if (submitError) {
      setStripeErrorMessage(submitError.message || submitError.code);
      setSubmittingToken(false);
      return;
    }

    // Use the clientSecret and Elements instance to confirm the setup
    return stripe.confirmSetup({
      elements,
      clientSecret,
      confirmParams: {
        return_url: 'https://tunnel.kyochon.fr/order/123/complete',
      },
      redirect: "if_required",
    }).then((result) => {
        if (result.error) {
          setStripeErrorMessage(result.error.message);
        } else {
          // Success.
          setStripeErrorMessage(null);
          return props.onSubmit(result.setupIntent.payment_method);
        }
      })
      .catch((_error) => {
        setStripeErrorMessage(t("credit_card.validating_error"));
      })
      .finally(() => {
        setSubmittingToken(false);
      });
  }

  const active = !(submitting || submittingToken);
  const submitLabel = active ? t("credit_card.add") : t("standby");

  const stripeElementClasses = ["StripeElement"]
  if (stripeFocused) {
    stripeElementClasses.push(styles.stripeFocused);
  }
  if (stripeErrored) {
    stripeElementClasses.push(styles.stripeErrored);
  }

  return (
    <form className={styles.module} onSubmit={submit}>
      <div className="fields">
        <p className={textClass}>
          <Trans
            i18nKey="common:payment_element.authorize_text"
            components={{
              b: <span className="sg-font-bold"/>
            }}
            values={{
              shopName: props.shopName,
            }}
          />
        </p>
        <PaymentElement
          onFocus={() => setStripeFocused(true)}
          onBlur={() => setStripeFocused(false)}
          onChange={(event) => {
            const inError = !!event.error;
            if (stripeErrored !== inError) {
              setStripeErrored(inError);
            }}
          }
          className={stripeElementClasses.join(" ")}
        />
      </div>
      <div className={buttonsClass}>
        <Button label={submitLabel} primary={true} onClick={submit} active={active} />
        { props.onCancel && (
            <Button label={t("cancel")} active={active} onClick={props.onCancel}
              theme={Button.THEMES.BLUE_OUTLINE}
              addCancelToTopRight={true} />)
        }
      </div>

      <FormError error={stripeErrorMessage} />
    </form>
  );
}
